export default __webpack_public_path__ + "static/media/corn.23d5186a.jfif";